var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconInfo18 = function SvgAIconInfo18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15Z",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09091 11.75V8.47727H8",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00684 6.25C9.05619 6.25 9.09621 6.20999 9.09621 6.16064",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91895 6.16064C8.91888 6.18436 8.92828 6.20713 8.94505 6.2239C8.96183 6.24067 8.98459 6.25006 9.00832 6.25",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00734 6.07129C8.98362 6.07122 8.96085 6.08062 8.94408 6.09739C8.9273 6.11416 8.91791 6.13693 8.91797 6.16064",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09621 6.16064C9.09621 6.11129 9.05619 6.07129 9.00684 6.07129",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconInfo18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOSAxNUMxMi4zMTM3IDE1IDE1IDEyLjMxMzcgMTUgOUMxNSA1LjY4NjI5IDEyLjMxMzcgMyA5IDNDNS42ODYyOSAzIDMgNS42ODYyOSAzIDlDMyAxMi4zMTM3IDUuNjg2MjkgMTUgOSAxNVoiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuMDkwOTEgMTEuNzVWOC40NzcyN0g4IiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05LjAwNjg0IDYuMjVDOS4wNTYxOSA2LjI1IDkuMDk2MjEgNi4yMDk5OSA5LjA5NjIxIDYuMTYwNjQiIHN0cm9rZS13aWR0aD0iMS40IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguOTE4OTUgNi4xNjA2NEM4LjkxODg4IDYuMTg0MzYgOC45MjgyOCA2LjIwNzEzIDguOTQ1MDUgNi4yMjM5QzguOTYxODMgNi4yNDA2NyA4Ljk4NDU5IDYuMjUwMDYgOS4wMDgzMiA2LjI1IiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05LjAwNzM0IDYuMDcxMjlDOC45ODM2MiA2LjA3MTIyIDguOTYwODUgNi4wODA2MiA4Ljk0NDA4IDYuMDk3MzlDOC45MjczIDYuMTE0MTYgOC45MTc5MSA2LjEzNjkzIDguOTE3OTcgNi4xNjA2NCIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS4wOTYyMSA2LjE2MDY0QzkuMDk2MjEgNi4xMTEyOSA5LjA1NjE5IDYuMDcxMjkgOS4wMDY4NCA2LjA3MTI5IiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";